export default "__VITE_ASSET__DW58gOqg__"